if (typeof window !== 'undefined') {
  require('yet-another-react-lightbox/styles.css');
}